import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_DocumentExecutionNotesForm = _resolveComponent("DocumentExecutionNotesForm")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_DocumentExecutionNotesList = _resolveComponent("DocumentExecutionNotesList")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.documentExecutionNotesDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.notes')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_FabButton, {
            icon: "fas fa-plus",
            onClick: _ctx.createNewNote
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_ctx.activeTab === 1)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "kn-button kn-button--primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportNotes('pdf'))),
              disabled: _ctx.exportButtonDisabled
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.main.exportInPDF')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 1)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "kn-button kn-button--primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportNotes('rtf'))),
              disabled: _ctx.exportButtonDisabled
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.main.exportInRTF')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary p-ml-auto",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.activeTab === 0)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              class: "kn-button kn-button--primary",
              onClick: _ctx.saveNote,
              disabled: _ctx.saveButtonDisabled
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_TabView, {
        activeIndex: _ctx.activeTab,
        "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.note')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DocumentExecutionNotesForm, { selectedNote: _ctx.selectedNote }, null, 8, ["selectedNote"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.notesList')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DocumentExecutionNotesList, {
                propNotes: _ctx.notes,
                document: _ctx.document,
                onEditNote: _ctx.onEditNote,
                onDeleteNote: _ctx.onDeleteNote
              }, null, 8, ["propNotes", "document", "onEditNote", "onDeleteNote"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}